import { render, staticRenderFns } from "./SmsBroadcastStatistic.vue?vue&type=template&id=5f2f0797&lang=html"
import script from "./SmsBroadcastStatistic.vue?vue&type=script&lang=js"
export * from "./SmsBroadcastStatistic.vue?vue&type=script&lang=js"
import style0 from "./SmsBroadcastStatistic.vue?vue&type=style&index=0&id=5f2f0797&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports